
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.idb-label-data-heading {
  display: flex;
  gap: 0.25rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem
}

.heading-label {
  white-space: nowrap;
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  text-transform: uppercase;
  color: var(--gray-professional-lighten-1);
  display:inherit
}

.heading-data {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
  text-transform: uppercase;
  color: var(--blue-responsible-darken-2)
}
`;